export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_09.1dd5d308.jpg";